import * as React from "react";
import { forwardRef } from "react";
const SvgCheckBlue = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 8, viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { id: "Vector 158", d: "M1.83865 4.13906L3.73599 6.03639L8.1631 1.60928", stroke: "#17A4C2", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgCheckBlue);
export default ForwardRef;
